import React from "react";
import logo from "../image/hifi.png"; // Replace with your logo path

const Footer = () => {
  return (
    <footer class="site-footer">
    <div class="container text-center">
      {/* <!-- Logo --> */}
      <div class="footer-logo mb-3">
        <img src={logo} alt="hifi Logo" />
      </div>

      {/* <!-- Divider --> */}
      <div class="footer-divider"></div>

      {/* <!-- Text --> */}
      <div class="footer-text">
        © 2025 Hifi Internationals | All Rights Reserved.
      </div>
    </div>
  </footer>
  );
};

export default Footer;
